/* eslint-disable jsx-a11y/alt-text */
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'

import AppContext from 'src/appContext'

type LayoutProps = {
  children: React.ReactNode
  className?: string
  registrationState?: any
}

const Layout = ({ children, className, registrationState }: LayoutProps) => {
  const { translate } = useTranslations()

  return (
    <AppContext.Consumer>
      {() => {
        return (
          <div style={{ minHeight: '60vh' }}>
            <div className="container u-pt-32 u-pt-lg-64 u-pb-lg-0 u-px-lg-0 ">
              {(registrationState !== 3 && registrationState !== 7) && (
                <h1 className="u-pl-0 u-pl-lg-16 u-mb-0 u-fs-28 u-fs-lg-40">
                  {translate('RegisterBusiness_Heading')}
                </h1>
              )}
            </div>
            <div
              className={
                className ??
                `u-bg-light-gray ${(registrationState !== 3 && registrationState !== 7) ? 'u-pt-lg-64' : ''} u-pb-96`
              }>
              <div className="container">{children}</div>
            </div>
          </div>
        )
      }}
    </AppContext.Consumer>
  )
}
export default Layout
